export default "__VITE_ASSET__ac3cf0eb__"